import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class ToastService {

  constructor(
    private _toastCtrl: ToastController
  ) { }

  /**
   * Show toast
   *
   * @param   {object}  options  Ionic toast properties
   * @return  {void}
   */

  show = (options: ToastOptions = {}): void => {
    const css = (options as any)?.cssClass || '';
    const hasBrandClass = typeof css === 'string' ? css.split(/\s+/).includes('toast-brand') : Array.isArray(css) ? css.includes('toast-brand') : false;

    /** Merge options with defaults (avoid forcing Ionic 'success' color when brand class is used) */
    const defaults: ToastOptions = {
      message: 'Ok!',
      duration: 5000
    } as ToastOptions;
    if (!hasBrandClass) {
      (defaults as any).color = 'success';
    }

    this._toastCtrl.create(Object.assign(defaults, options))

      /** Show toast */

      .then(result => {

        result.present();
      });
  }

}
